import React from "react";
import "../App.css";
import ReactGA from 'react-ga';

class FeedbackEmoji extends React.Component {
    boundListener = this.sendAnalytics.bind(this);
    radioButton = React.createRef();

    render() {
        return <>
            <input ref={this.radioButton} id={this.props.name} className="Feedback-Radio" name={this.props.meterName} type="radio" />
            <label htmlFor={this.props.name}>
                <img src={this.props.src} alt={this.props.name} width="30" height="30"></img>
            </label>
        </>;
    }

    componentDidMount() {
        window.addEventListener("unload", this.boundListener);
    }

    componentWillUnmount() {
        window.removeEventListener("unload", this.boundListener);
    }

    sendAnalytics() {
        if (this.radioButton.current.checked) {
            ReactGA.event({
                category: "feedback-interaction",
                label: `${window.location.pathname + window.location.search}-${this.props.name}`,
                action: "selected"
            });
        }
    }
}

export default FeedbackEmoji;